import React from "react";
import Person from "@mui/icons-material/Person";
import SmartToy from "@mui/icons-material/SmartToy";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AccountCircle from "@mui/icons-material/AccountCircle";

/**
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestPlayer} player
 * @returns {React.ReactElement}
 */
export const getPlayerTypeIcon = (player) => {
  if (player.anonymous) {
    return <VisibilityOff fontSize="small" />;
  } else if (player.ai) {
    return <SmartToy fontSize="small" />;
  } else if (player.user) {
    return <AccountCircle fontSize="small" />;
  } else {
    return <Person fontSize="small" />;
  }
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestPlayer} player
 * @returns {string}
 */
export const getPlayerTypeLabel = (player) => {
  if (player.anonymous) {
    return "Anonymous";
  } else if (player.ai) {
    return "AI";
  } else if (player.user) {
    return "Designer";
  } else {
    return "Player";
  }
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestPlayer} player
 * @returns {string}
 */
export const getPlayerTypeTooltip = (player) => {
  if (player.anonymous) {
    return "Anonymous player";
  } else if (player.ai) {
    return "AI player";
  } else if (player.user) {
    return "Designer/user player";
  } else {
    return "Human player";
  }
};
